module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("guest_preview", [["div",{"class":"disable-player-block","id":"flash-player"},[["div",{"class":"permition-wrapper"},[["div",{"class":"disable-banner-link"}],["div",{"class":"disable-player-scene-img"},[["img",{"src":""},[],[["_resources.primary.url","src",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/guestpreview.tpl
// module id = 731
// module chunks = 4